import { render } from "./PiarAdjustmentsTab.vue?vue&type=template&id=3ba04918&scoped=true&ts=true"
import script from "./PiarAdjustmentsTab.vue?vue&type=script&lang=ts"
export * from "./PiarAdjustmentsTab.vue?vue&type=script&lang=ts"

import "./PiarAdjustmentsTab.vue?vue&type=style&index=0&id=3ba04918&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba04918"]])

export default __exports__